import { colors } from "../../../data/colors";
import { stdObject } from "../../../data/types/stdObject";

export const writeCommButtons = ({
  t,
  name,
  serie,
  commission,
  openWindow,
  setMsg,
  setModalData,
  closeMsg,
  reverseComm,
}: stdObject) => {
  return {
    BUTTONCOYP: {
      style: {
        color:
          commission.ESTCOYP === 2
            ? colors.green
            : commission.ESTCOYP === 1
              ? colors.orange
              : colors.grey,
        cursor: "pointer",
      },
      onClick: () =>
        openWindow({
          msgName: "payments",
          modalInfo: {
            title: t("p.commission"),
            label: `${commission.NOMCOYP} (${commission.CODCOYP})`,
            type: "COYP",
            doc: "COYP",
            isEdit: true,
            serie,
            code: commission.CODCOYP,
          },
        }),
    },
    BUTTONDELCOYP: {
      style: { color: colors.red, cursor: "pointer" },
      onClick: () => {
        setMsg("custom1");
        setModalData({
          title: name,
          label: t("p.askDeleteComm"),
          buttons: [
            {
              label: t("p.reverse"),
              onClick: () => {
                reverseComm(commission.CODCOYP);
              },
              color: colors.red,
            },
            {
              label: t("p.cancel"),
              onClick: closeMsg,
              color: colors.darkGrey,
            },
          ],
        });
      },
    },
  };
};
